import { Box, Grid } from "@mui/material";
import { useState } from "react";
import SectionTitle from "../components/SectionTitle";
import ProductCard from "../components/ProductCard";
import EnquiryDialog from "../components/EnquiryDialog";

export default function ProductsSection() {
  const [open, setOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");

  const handleOpen = (product) => {
    setSelectedProduct(product);
    setOpen(true);
  };

  return (
    <Box px={{ xs: 2, md: 8 }} py={{ xs: 3, md: 5 }}>
      <SectionTitle
        title="Premium Organic Solutions"
        subtitle="Chemical-free products for sustainable farming"
      />

      <Grid container spacing={4} mt={4} justifyContent={'center'} gap={5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <ProductCard
            title="Vermiwash"
            discount="20% OFF"
            description="Premium organic extract derived from vermicompost."
            prices={[
              { label: "1 Litre", price: "₹40" },
              { label: "5 Litres", price: "₹150" },
              { label: "25 Litres", price: "₹450" },
              { label: "50 Litres", price: "₹700" }
            ]}
            onEnquiry={() => handleOpen("Vermiwash")}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <ProductCard
            title="Vermicompost"
            discount="10% OFF"
            description="100% organic compost rich in nutrients."
            prices={[
              { label: "1 Kg", price: "₹20" },
              { label: "5 Kg", price: "₹80" },
              { label: "25 Kg", price: "₹300" },
              { label: "50 Kg", price: "₹550" }
            ]}
            onEnquiry={() => handleOpen("Vermicompost")}
          />
        </Grid>
      </Grid>

      <EnquiryDialog
        open={open && !!selectedProduct}
        handleClose={() => setOpen(false)}
        product={selectedProduct}
      />
    </Box>
  );
}
